export var transformToFormState = function (nomModules) {
    var output = nomModules.map(function (module) {
        var returnObject = { nomId: module.id, always_activate: module.always_activate };
        return returnObject;
    });
    return { netopsModules: output };
};
